'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_totp_Migration$Account(secret, name, issuer, algorithm, digits, kind, period) {
  this.jA = null;
  this.n8 = null;
  this.n6 = null;
  this.ow = 0;
  this.ox = 0;
  this.n7 = 0;
  this.lK = 0;
  this.jA = secret;
  this.n8 = name;
  this.n6 = issuer;
  this.ow = algorithm;
  this.ox = digits;
  this.n7 = kind;
  this.lK = period;
}
export { $c_Lpresto_ui_totp_Migration$Account as $c_Lpresto_ui_totp_Migration$Account };
$p = $c_Lpresto_ui_totp_Migration$Account.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_totp_Migration$Account;
/** @constructor */
function $h_Lpresto_ui_totp_Migration$Account() {
}
export { $h_Lpresto_ui_totp_Migration$Account as $h_Lpresto_ui_totp_Migration$Account };
$h_Lpresto_ui_totp_Migration$Account.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Account"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.jA));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.n8));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.n6));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.ow);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.ox);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.n7);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.lK);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 7);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_ui_totp_Migration$Account) && (((((((this.ow === x$0.ow) && (this.ox === x$0.ox)) && (this.n7 === x$0.n7)) && (this.lK === x$0.lK)) && (this.jA === x$0.jA)) && (this.n8 === x$0.n8)) && (this.n6 === x$0.n6))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 7;
});
$p.s = (function() {
  return "Account";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.jA;
      break;
    }
    case 1: {
      return this.n8;
      break;
    }
    case 2: {
      return this.n6;
      break;
    }
    case 3: {
      return this.ow;
      break;
    }
    case 4: {
      return this.ox;
      break;
    }
    case 5: {
      return this.n7;
      break;
    }
    case 6: {
      return this.lK;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.GV = (function() {
  return ((this.n6 === "") ? this.n8 : ((this.n6 + ": ") + this.n8));
});
function $isArrayOf_Lpresto_ui_totp_Migration$Account(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mp)));
}
export { $isArrayOf_Lpresto_ui_totp_Migration$Account as $isArrayOf_Lpresto_ui_totp_Migration$Account };
var $d_Lpresto_ui_totp_Migration$Account = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_totp_Migration$Account, "presto.ui.totp.Migration$Account", ({
  mp: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_ui_totp_Migration$Account as $d_Lpresto_ui_totp_Migration$Account };
//# sourceMappingURL=presto.ui.totp.-Migration$-Account.js.map
